module.exports = __webpack_public_path__ + "img/notfound.260d3db6.png";